import axiosClient from '../../../config/axios-client'

const SponsorService = {
  getSponsors() {
    return axiosClient.get(`/dashboard/sponsors`)
  },
  // createSponsor(payload) {
  //   return axiosClient.post(`/dashboard/sponsors`, payload)
  // },
  createSponsor(payload) {
    return axiosClient.post(`/dashboard/sponsors/`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getSponsor(sponsorId) {
    return axiosClient.get(`/dashboard/sponsors/${sponsorId}`)
  },
  updateSponsor(sponsorId, payload) {
    return axiosClient.post(`/dashboard/sponsors/${sponsorId}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  deleteSponsor(sponsorId) {
    return axiosClient.delete(`/dashboard/sponsors/${sponsorId}`)
  },
  changeSponsorStatus(sponsorId) {
    return axiosClient.post(`/dashboard/sponsors/${sponsorId}/change/status`)
  },
  getSponsorsRequests() {
    return axiosClient.get(`/dashboard/sponsors/requests`)
  },
  changeSponsorRequestStatus(sponsorRequestId, newRequestStatus) {
    return axiosClient.post(
      `/dashboard/sponsors/requests/${sponsorRequestId}`,
      newRequestStatus,
    )
  },
}

export default SponsorService
